import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_LIST_MY_FAIL,
  ORDER_LIST_MY_REQUEST,
  ORDER_LIST_MY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
} from "../Constants/OrderConstants";
import { CART_CLEAR_ITEMS } from "../Constants/CartConstants";
import { logout } from "./userActions";
import URL from "../Url";

// CREATE ORDER (authenticated)
export const createOrder = (order) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/orders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
      body: JSON.stringify(order),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to create order");

    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
    dispatch({ type: CART_CLEAR_ITEMS, payload: data });
    localStorage.removeItem("cartItems");
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: ORDER_CREATE_FAIL, payload: error.message });
  }
};

// GUEST CREATE ORDER
export const createGuestOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const res = await fetch(`${URL}/api/orders/guest`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderData),
    });

    const data = await res.json();

    if (res.status === 409 && data?.emailExists) {
      dispatch({ type: ORDER_CREATE_FAIL, payload: "__EMAIL_EXISTS__" });
      return;
    }

    if (!res.ok) throw new Error(data?.message || "Failed to create guest order");

    if (data.guestOrderToken) {
      sessionStorage.setItem("guestOrderToken", data.guestOrderToken);
    }

    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
    dispatch({ type: CART_CLEAR_ITEMS });
    localStorage.removeItem("cartItems");
  } catch (error) {
    dispatch({ type: ORDER_CREATE_FAIL, payload: error.message });
  }
};

// ORDER DETAILS — works for both logged-in users and guests
export const getOrderDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });

    const { userLogin: { userInfo } } = getState();

    let authToken = userInfo?.token;
    if (!authToken) authToken = sessionStorage.getItem("guestOrderToken");

    const res = await fetch(`${URL}/api/orders/${id}`, {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to get order details");

    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: ORDER_DETAILS_FAIL, payload: error.message });
  }
};

// ORDER PAY — works for both logged-in users and guests
export const payOrder = (orderId, paymentResult) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_PAY_REQUEST });

    const { userLogin: { userInfo } } = getState();

    let authToken = userInfo?.token;
    if (!authToken) authToken = sessionStorage.getItem("guestOrderToken");

    const res = await fetch(`${URL}/api/orders/${orderId}/pay`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
      },
      body: JSON.stringify(paymentResult),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Payment failed");

    dispatch({ type: ORDER_PAY_SUCCESS, payload: data });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: ORDER_PAY_FAIL, payload: error.message });
  }
};

// USER ORDERS
export const listMyOrders = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_LIST_MY_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/orders/`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to fetch orders");

    dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: ORDER_LIST_MY_FAIL, payload: error.message });
  }
};